import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UserGroupAclEffects } from './user-group-acl.effects';
import { userGroupAclReducer } from './user-group-acl.reducer';
import { AccessControlListService } from '@era/security-sdk';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('userGroupAcls', userGroupAclReducer),
    EffectsModule.forFeature([UserGroupAclEffects]),
  ],
  providers: [AccessControlListService],
})
export class UserGroupAclStoreModule {}
